import { BillingCycleTypes } from '../../domain/invoice';

export interface IReactivateLicenseRequestv2 {
    LicenseID: number;
    CreditCardID: number;
    BillingCycle: BillingCycleTypes;
    OverWriteSetup: number;
    FreeReactivation: boolean;
    NewProductID: number;
    IncludeYARD: boolean;
    assignToMember: boolean;
    keepAssigned: boolean;
    designerName: string;
    designerEmail: string;
}


export class ReactivateLicenseRequestv2 implements IReactivateLicenseRequestv2 {
    LicenseID: number;
    CreditCardID: number;
    BillingCycle: BillingCycleTypes;
    OverWriteSetup: number;
    FreeReactivation: boolean;
    NewProductID: number;
    IncludeYARD: boolean;
    assignToMember: boolean = true;
    keepAssigned: boolean = false;
    designerName: string = '';
    designerEmail: string = '';
}
